// extracted by mini-css-extract-plugin
export default {"CurPage":"CurPage_CurPage__IF1qB","currentPage":"CurPage_currentPage__GbYsu"};